import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { debounce } from "throttle-debounce";
import { CustomTextField } from "../modals/employee/DeleteEmployeesModal/components/StepHeader/styles";
import { translate as t } from "../../../infrastructure/translate/localization";
import useStyles from "./styles";

export default function SearchField({ action, isLoading }) {
  const { searchButton, searchIcon } = useStyles();

  const [searchValue, setSearchValue] = useState("");

  const handleCallback = useCallback(
    () =>
      debounce(600, false, (value) => {
        action(value);
      }),
    [action]
  );

  const handleSearch = (e) => {
    setSearchValue(e.target.value);
    handleCallback(e.target.value);
  };

  const handleKeyPress = (e) => {
    const { key } = e;
    if (key === "Enter") {
      action(e.target.value);
    }
  };

  const handleSearchClick = () => action(searchValue);
  return (
    <>
      <CustomTextField
        variant="outlined"
        onChange={handleSearch}
        onKeyPress={handleKeyPress}
        disabled={isLoading}
      />

      <Button
        className={searchButton}
        disabled={isLoading}
        onClick={handleSearchClick}
        startIcon={<SearchIcon className={searchIcon} />}
      >
        {t("actions.search")}
      </Button>
    </>
  );
}

SearchField.defaultProps = {
  isLoading: false,
};

SearchField.propTypes = {
  action: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
